module.exports = __webpack_public_path__ + "static/media/feature-workflow.07b93fca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/feature-workflow.svg
// module id = 13909
// module chunks = 0